import { TopMenuProvider } from "./components/base/topMenuContext";
import Auth from "./configurations/auth/authContext";
import Main from "./Main";
import './configurations/native/BackListener'
import { GlobalLoaderProvider } from "./configurations/useGlobalLoader";
import useQRScanner from "./configurations/useQRScanner";
import ForCameraOpen from "./configurations/native/ForCameraOpen";

function App() {
  const { isQRScanerOn } = useQRScanner()
  return (
    <>
      {isQRScanerOn && <ForCameraOpen />}
      <div className={isQRScanerOn ? "hidden" : "bg-transparent min-h-screen"}>
        <GlobalLoaderProvider>
          <TopMenuProvider>
            <Auth>
              <Main />
            </Auth>
          </TopMenuProvider>
        </GlobalLoaderProvider>
      </div>
    </>
  );
}

export default App;
